import FreespinWinController from '../../controllers/freespin/FreeSpinWinController';
import MainGridController from '../../controllers/grid/MainGridController';
import { COMPONENTS } from '../../lib/constants';
import { FreespinWinGrid } from './FreespinWinGrid';

export const FreespinWinView = {
	name: COMPONENTS.FREE_SPIN_WIN,
	child: true,
	zIndex: 2,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: FreespinWinController,
			name: 'FreespinWinController',
			config: {
				holder: 'freespin_win_holder'
			}
		},
		{
			Controller: MainGridController,
			name: 'FreespinWinGrid',
			config: FreespinWinGrid
		}
	],
	components: [
		{
			name: 'freespin_win_holder',
			type: 'Sprite',
			components: [
				{
					name: 'bg',
					type: 'Sprite',
					img: 'dialog_main_bg',
					position: { x: 0, y: 0 }
				},
				{
					name: "bg_border",
					type: "Sprite",
					img: "sm_modal_frame",
					position: { x: -20, y: -20 },
				  },
				{
					name: 'header',
					type: 'Text',
					text: 'QUEST_PROMPT_HEADER',
					position: { x: 587 / 2 + 10, y: 30 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'FREE_SPIN_WIN_TITLE',
					type: 'Text',
					text: 'FREE_SPIN_WIN_TITLE',
					position: { x: 587 / 2, y: 100 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'FREE_SPIN_TOTAL_AMOUNT',
					type: 'Text',
					text: 'FREE_SPIN_TOTAL_AMOUNT',
					position: { x: 587 / 2, y: 185 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'FREE_SPIN_TOTAL_TEXT',
					type: 'Text',
					text: 'FREE_SPIN_TOTAL_TEXT',
					position: { x: 587 / 2, y: 270 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'FREE_SPIN_BTN',
					type: 'ActionButton',
					bg: 'dialog_yes_btn',
					position: { x: 587 / 2, y: 395 }
				}
			]
		}
	]
};
